import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { UserStore } from '@cxc/core/services';

import { ROUTE_PATHS } from '@configs/route-paths.const';

export const unloggedGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const user = userStore.get();

  if (!user.logged) {
    return true;
  }

  // Same rule as after 2FA: HomeRedirectComponent picks the page from the profile.
  router.navigate([ROUTE_PATHS.DASHBOARD]);

  return false;
};
